import Vue from 'vue'
import App from './App.vue'
import '@/assets/icon/iconfont.css'
import '@/assets/icon/iconfont.js'
import './assets/font_8olfxwtp0zv/iconfont.css'//阿里巴巴图标库的引入
import './style/index.css'//主题切换的通用样式
import 'swiper/css/swiper.css'//swiper css组件
import 'element-ui/lib/theme-chalk/index.css'//引用element css组件
import ElementUI from 'element-ui'//引用element 组件
import router from './router'//引入路由
import store from './store/store'//引入vuex
import i18n from './lang/index'
Vue.config.productionTip = false//关闭vue中的提示 true 是开启
Vue.use(ElementUI);//挂在ElementUI


new Vue({
  render: h => h(App),
  router,
  store,// 在这里注入store实例后，所有的组件都可以通过 this.$store去访问store实例
  i18n
}).$mount('#app')
